import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {BsModalRef} from 'ngx-bootstrap/modal';

declare var $: any;

@Component({
  selector: 'app-request-discount-voucher',
  templateUrl: './request-discount-voucher.component.html',
  styleUrls: ['./request-discount-voucher.component.css']
})
export class RequestDiscountVoucherComponent implements OnInit {

  @Output() requestCloseModal = new EventEmitter();

  constructor(private http: HttpClient, public bsModalRef: BsModalRef, private router: Router) { }

  ngOnInit() {
    $.HSCore.components.HSValidation.init('.js-validate');

    var self = this;
    document.getElementById('voucherForm').onsubmit = function() {
      return self.onFormSubmit();
    };
  }

  onFormSubmit() {
    const nameField = <HTMLFormElement>(document.getElementById('voucherName'));
    const emailField = <HTMLFormElement>(document.getElementById('voucherEmail'));
    if (emailField.checkValidity() && nameField.checkValidity()) {

      const formObj = {
        "name": nameField.value,
        "email": emailField.value,
        "origin": this.router.url.substring(this.router.url.lastIndexOf('/') + 1)
      };
      const serializedForm = JSON.stringify(formObj);
      console.log("success! " + serializedForm);
      this.http.post("https://a895p3q6q7.execute-api.us-east-1.amazonaws.com/request-discount-voucher", serializedForm)
          .subscribe(
              data => console.log("success!", data),
              error => console.error("error!", error)
          );
      this.closeModal();
    }
    return false;
  }

  closeModal() {
    this.bsModalRef.hide();
    sessionStorage.removeItem('modalShown');
  }
}
